import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4132bd62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white py-24 px-16 rounded-2" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 col-lg-3 col-xl-2 mb-16 mb-lg-0" }
const _hoisted_4 = { class: "col-12 col-lg-9 col-xl-10" }
const _hoisted_5 = { class: "d-flex h-100" }
const _hoisted_6 = {
  key: 0,
  class: "h-100 w-100 d-flex flex-column align-items-center justify-content-center text-center"
}
const _hoisted_7 = { class: "h5 title text-primary py-48 py-lg-0 mb-lg-48" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-add me-12",
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_line_chart = _resolveComponent("v-line-chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formValuesStructure, (formField) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: formField.key
          }, [
            (formField.type !== 'date')
              ? (_openBlock(), _createBlock(_component_v_button, {
                  key: 0,
                  variant: "selector",
                  class: _normalizeClass(["mb-8 me-8", {'active': _ctx.measureName === formField.key}]),
                  "aria-label": formField.label,
                  onClick: ($event: any) => (_ctx.setTypeMeasure(formField.key, formField.label))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(formField.label)), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "aria-label", "onClick"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (!_ctx.measures || !_ctx.measures.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('No hay datos de medidas')), 1),
                (_ctx.can('professional.expedient.form.store'))
                  ? (_openBlock(), _createBlock(_component_v_button, {
                      key: 0,
                      variant: "secondary",
                      class: "btn-icon me-16",
                      "aria-label": _ctx.$t('Añadir nueva medida'),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('show-form-create-modal')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('Añadir medida')), 1)
                      ]),
                      _: 1
                    }, 8, ["aria-label"]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createBlock(_component_v_line_chart, {
                key: 1,
                options: _ctx.options
              }, null, 8, ["options"]))
        ])
      ])
    ])
  ]))
}